<script setup lang="ts">
import { computed, ref } from 'vue'
import { adverseSearchAdapter as adapter, adverseSearchDefaults as defaults } from '../utils/searchAdapter'
import { adverseSearchState } from '../utils/searchFilters'
import UniversalSearchFilter from '@/components/searchFilter/UniversalSearchFilter.vue'
import type { FilterState } from '@/components/searchFilter/types'
import { useApiStore } from '@/modules/apiStore/stores/apiStore'

const emit = defineEmits<{ apply: [] }>()
const store = useApiStore()
const control = ref<InstanceType<typeof UniversalSearchFilter> | null>(null)
const state = computed(() => adverseSearchState(store.filters))
function apply(value: FilterState) {
  store.resetFilters()
  store.filters.search = value.search
  store.filters.advanced = value.filter.conditions.length ? JSON.stringify(value.filter) : ''
  emit('apply')
}
defineExpose({
  openField: (field: string) => control.value?.openField(field),
  openPanel: () => control.value?.openPanel(),
  closePanel: () => control.value?.closePanel(),
})
</script>

<template>
  <UniversalSearchFilter
    ref="control"
    :model-value="state"
    :adapter="adapter"
    scope-label="Анкеты"
    add-placeholder="Добавить поле или анкету"
    :defaults="defaults"
    :error="store.adverseSearchError"
    @update:model-value="apply"
  />
</template>
